import React, { useEffect } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import GivingOpportunities from "../Content/GivingOpportunities";
import WaysToGiveContent from '../Content/WaysToGiveContent'
import { useLocation } from "react-router-dom";

function EndowmentFund() {
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo({ top: "0", behavior: "smooth"})
    },[pathname])

    return (
        <div>
            <Header />
            <GivingOpportunities />
            <WaysToGiveContent/>
            <Footer />
        </div>
    )
}

export default EndowmentFund;